import React, { useState, useEffect } from "react";
import { app, auth, firestore, storage } from "../../firebase";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  updateDoc,
  serverTimestamp
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getAuth } from "firebase/auth";
import "./post.css";
import { comfortOptions, audioOptions, sigurantaOptions, asistentaOptions } from "./optiuni";

import { marciDeMasini } from "./listcars";
import { listaAnFabricatie } from "./anFabricatie";
import { Navigate } from "react-router-dom";

async function compressImage(file, quality) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;
      image.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Calculăm noile dimensiuni ale imaginii pentru compresie
        const maxWidth = 800;
        const maxHeight = 600;
        let newWidth, newHeight;

        if (image.width > image.height) {
          newWidth = maxWidth;
          newHeight = (image.height / image.width) * maxWidth;
        } else {
          newHeight = maxHeight;
          newWidth = (image.width / image.height) * maxHeight;
        }

        canvas.width = newWidth;
        canvas.height = newHeight;

        // Desenăm imaginea pe canvas cu noile dimensiuni
        ctx.drawImage(image, 0, 0, newWidth, newHeight);

        // Obținem imaginea comprimată sub formă de Blob
        canvas.toBlob((blob) => {
          resolve(new File([blob], file.name, { type: 'image/jpeg' }));
        }, 'image/jpeg', quality);
      };
    };

    reader.readAsDataURL(file);
  });
}


const AddProject = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  const [showProgressModal, setShowProgressModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

const [selectedComponent, setSelectedComponent] = useState("portfolio");
  const [material, setMaterial] = useState("");
  const [greutate, setgreutate] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedMainImg, setSelectedMainImg] = useState([]);
  const [pretCuTVA, setPretCuTVA] = useState(false);
  const [pret, setPret] = useState("");
  const [discount, setDiscount] = useState("");
 const [um, setum] = useState("");
 const [titlu, setTitlu] = useState("");
 const [dimensiune, setdimensiune] = useState("");
 const [comanda, setComanda] = useState(false);
  const [sku, setsku] = useState("")

  const handleLinkClick = (componentName) => {
    setSelectedComponent(componentName);
   
  };

  const handleTvaChange = (e) => {
    const isChecked = e.target.checked;
    setPretCuTVA(isChecked);

  };



  const handleComanda = (e) => {
    const isChecked = e.target.checked;
    setComanda(isChecked);

  };
 
  const handleMaterial = (e) => {
    setMaterial(e.target.value.toUpperCase());
  };

  const handlegreutate = (e) => {
    setgreutate(e.target.value.toUpperCase());
  };


  const handleTitlu = (e) => {
    setTitlu(e.target.value);
  };



  const handleMainImgChange = async (e) => {
    const image = e.target.files[0];
    
    if (image) {
      try {
        const compressedImage = await compressImage(image, 0.8); // Comprimăm imaginea
        setSelectedMainImg([compressedImage]); // Setăm imaginea comprimată în starea componentei
      } catch (error) {
        console.error("Eroare la comprimarea imaginii:", error);
      }
    }
  };
  

// Funcția pentru manipularea imaginilor secundare atunci când utilizatorul selectează imagini
const handleImagesChange = async (e) => {
  const images = e.target.files;
  const imagesArray = Array.from(images);

  // Limităm numărul de imagini la 25 (dacă utilizatorul selectează mai multe)
  const selectedImages = imagesArray.slice(0, 25);

  const compressedImages = [];

  // Comprimăm fiecare imagine și adăugăm imaginea comprimată la listă
  for (const image of selectedImages) {
    try {
      const compressedImage = await compressImage(image, 0.8); // Comprimăm imaginea cu o calitate de 0.8 (80%)
      compressedImages.push(compressedImage);
    } catch (error) {
      console.error("Eroare la comprimarea imaginilor:", error);
    }
  }

  // Setăm imaginile comprimate în starea componentei
  setSelectedImages(compressedImages);
};


 
  const handledimensiune = (e) => {
   setdimensiune(e.target.value);
  };

 

 
 

  const handlePret = (e) => {
    setPret(e.target.value.toUpperCase());
  };
  const handlePretNou = (e) => {
    setDiscount(e.target.value);
  };
 



  const handlesku = (e) => {
    setsku(e.target.value.toUpperCase());
  };
  const handleum = (e) => {
    let inputValue = e.target.value;
    let newValue = '';
  
    for (let i = 0; i < inputValue.length; i++) {
      if (i === 0 || (inputValue[i - 1] === '.' || inputValue[i - 1] === ';' || inputValue[i - 1] === '\n')) {
        // Capitalizează primul caracter din fiecare nou rând sau după un punct sau semn de punctuație
        newValue += inputValue[i].toUpperCase();
      } else {
        newValue += inputValue[i];
      }
    }
  
    setum(newValue);

  };

  const resetFileInputs = () => {
    const mainImageInput = document.getElementById("mainImage");
    const imagesInput = document.getElementById("images");

    if (mainImageInput) {
      mainImageInput.value = ""; // Resetează câmpul de fișier pentru imaginea principală
    }

    if (imagesInput) {
      imagesInput.value = ""; // Resetează câmpul de fișier pentru imagini secundare
    }
  };

  const maxProgress = 100;

  const updateProgress = () => {
    const increment = maxProgress / 1;
    let currentProgress = 0;

    const progressInterval = setInterval(() => {
      currentProgress += increment;
      setUploadProgress(currentProgress);

      if (currentProgress >= maxProgress) {
        clearInterval(progressInterval);
        setTimeout(() => {
          setShowProgressModal(false);
          setUploadProgress(0);
        }, 1000);
      }
    }, 1000);
  };

  const handleSubmit = async () => {
   
  
    try {
      console.log("Începem încărcarea...");
  
      setShowProgressModal(true);
  
      const postCollectionRef = collection(firestore, "post");
      const newDocRef = await addDoc(postCollectionRef, {
        userId: user.uid,
        titlu,
        sku,
        um,
        material,
        greutate,
        comanda,
        dimensiune,
        pret,
        pretCuTVA, 
        pretNou: discount,   
        createdAt: serverTimestamp()
      });
  
      console.log("Document adăugat cu succes:", newDocRef.id);
  
      await handleImageUploads(newDocRef.id);
  
      resetForm();
      updateProgress();
      alert("Produs incarcat cu succes");
      window.location.reload();
    } catch (error) {
      console.error("Eroare la adăugarea datelor în Firestore:", error);
      alert(`Eroare la adăugarea datelor în Firestore: ${error.message}`);
      setShowProgressModal(false);
    }
  };
  
  const handleImageUploads = async (docId) => {
    const postDocRef = doc(firestore, "post", docId);
  
    try {
      // Verificăm dacă există o imagine principală
      if (selectedMainImg && selectedMainImg.length === 1) {
        const mainImage = selectedMainImg[0];
        const uniqueName = `${Date.now()}_${mainImage.name}`;
        const storageRef = ref(storage, `mainImages/${uniqueName}`);
  
        console.log("Încărcăm imaginea principală:", mainImage.name);
        const snapshot = await uploadBytes(storageRef, mainImage);
        const downloadURL = await getDownloadURL(snapshot.ref);
  
        await updateDoc(postDocRef, {
          mainImage: { [uniqueName]: downloadURL },
        });
  
        console.log(`Imaginea principală ${mainImage.name} încărcată cu succes.`);
      }
  
      // Verificăm dacă există imagini secundare
      if (selectedImages && selectedImages.length > 0) {
        const imagesObject = {};
        const uploadPromises = selectedImages.map(async (image) => {
          const uniqueName = `${Date.now()}_${image.name}`;
          const storageRef = ref(storage, `images/${uniqueName}`);
  
          console.log("Încărcăm imaginea:", image.name);
          const snapshot = await uploadBytes(storageRef, image);
          const downloadURL = await getDownloadURL(snapshot.ref);
          
          imagesObject[uniqueName] = downloadURL;
          console.log(`Imaginea ${image.name} încărcată cu succes.`);
        });
  
        await Promise.all(uploadPromises); // Așteptăm încărcarea tuturor imaginilor
        await updateDoc(postDocRef, { images: imagesObject });
  
        console.log("Toate imaginile au fost încărcate cu succes.");
      }
    } catch (error) {
      console.error("Eroare la încărcarea imaginilor:", error);
      alert(`Eroare la încărcarea imaginilor: ${error.message}`);
    }
  };
  
  
  const resetForm = () => {
    
    setgreutate("");
   
    
    setPret("");
    setsku("");
    setDiscount("");
    setum("");
    setdimensiune("");
    setMaterial("");
    
    setComanda(false);
   
    setTitlu("");
   
    setSelectedMainImg([]);
    setSelectedImages([]);
    setPretCuTVA(false);
    resetFileInputs();
  };
  

  return (
    <div className="px-1 py-5">
      <div>
        <div className="row px-3 w-100">
          <div className="col-md-12 col-lg-12">
            <h4 className="mb-3">Adăugare produs</h4>
          {/* Comanda checkbox */}
          <div className="col-sm-2">
                  <div className="form-check form-check-inline mt-2 mb-4">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="comanda"
                      onChange={handleComanda}
                    />
                  <label className="form-check-label" htmlFor="comanda">
                  Pe stoc
                  </label>
                  </div>
                 
                </div>
                <div className="col-sm-12 mb-3">
                  <label htmlFor="titlu" className="form-label">
                    Titlu *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="titlu"
                    value={titlu}
                    
                    placeholder="Titlu produs.."
                    onChange={handleTitlu}
                    
                  />
                </div>
            <div>

              
              <div className="row g-3">

              
              

                <div className="col-sm-3">
                  <label htmlFor="sku" className="form-label" >
                    Cod produs
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="sku"
                    value={sku}
                    onChange={handlesku}
                    placeholder="SKU..."
                  />
                </div>

                <div className="col-sm-2">
                  <label htmlFor="um" className="form-label">
  Unitate masura *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="um"
                    value={um}
               placeholder="buc, bax, set de 5.."
                    onChange={handleum}
                  
                    required
                  />
                </div>

               
                <div className="col-sm-2">
                  <label htmlFor="material" className="form-label">
                   Material
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="material"
                    value={material}
                    onChange={handleMaterial}
                  placeholder="otel, aluminiu"
                  />
                </div>
                <div className="col-sm-2">
                  <label htmlFor="greutate" className="form-label">
                   Greutate (kg)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="greutate"
                    value={greutate}
                    onChange={handlegreutate}
                  placeholder="0.20 kg.."
                  />
                </div>

                <div className="col-sm-2">
                  <label htmlFor="dimensiune" className="form-label">
                   Dimensiuni (cm)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="dimensiune"
                    value={dimensiune}
                    onChange={handledimensiune}
                  placeholder="L x l x H"
                  />
                </div>
               
              </div>

            
              {/* Poze */}
              <div className="row gy-3 mt-1">
                <div className="col-sm-3">
                  <label htmlFor="mainImage" className="form-label">
                    Imagine principală *
                  </label>
                  <input
                    type="file"
                    className="form-control mb-2"
                    id="mainImage"
                    required
                    onChange={handleMainImgChange}
                  />
                  {selectedMainImg.length === 1 && (
                    <div className="text-center ">
                      <img
                        src={URL.createObjectURL(selectedMainImg[0])}
                        alt="ProjectIMG"
                        loading="lazy"
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="col-sm-6">
                  <label htmlFor="images" className="form-label">
                    Imagini - maxim 5 *
                  </label>
                  <input
                    type="file"
                    className="form-control mb-2"
                    id="images"
                    multiple
                    required
                    onChange={handleImagesChange}
                  />
                  {selectedImages.length > 0 && (
                    <div className="text-center ">
                      {selectedImages.slice(0, 5).map((image, index) => (
                        <img
                          key={index}
                          src={URL.createObjectURL(image)}
                          alt="ProjectIMGs"
                          loading="lazy"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "cover",
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>

              </div>
              <hr className="my-4" />

              {/* Pret */}
              <div className="row gy-3 ">
                <div className="col-sm-2">
                  <label htmlFor="pret" className="form-label">Preț *</label>
                  <input
                    type="number"
                    className="form-control"
                    id="pret"
                    value={pret}
                    onChange={handlePret}
                    placeholder="fara TVA"
                    required
                  ></input>
                </div>


                {/* <div className="col-sm-2">
                  <div className="form-check form-check-inline mt-4">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="tva"
                      onChange={handleTvaChange}
                    />
                  <label className="form-check-label" htmlFor="tva">
                  Preț cu TVA
                  </label>
                  </div>
                </div> */}
            
                <div className="col-sm-2">
                  <label htmlFor="discount" className="form-label">Preț redus*</label>
                  <input
                    type="number"
                    className="form-control"
                    id="discount"
                    value={discount}
                    onChange={handlePretNou}
                   placeholder="fara TVA"
                   required
                  ></input>
                </div>
                <hr className="my-4" />
              </div>

             
             

              <button
                className="w-100 btn btn-primary"
                onClick={handleSubmit}
              >
                Adaugare produs
              </button>
            
            </div>
          </div>
        </div>
      </div>
      {showProgressModal && (
        <div className="progress-modals">
          <div className="modal-contents">
            {uploadProgress < 100 ? (
              <>
                <p>Încărcare în progres...</p>
                <div className="progress-bar-containers">
                  <div
                    className="progress-bars"
                    style={{ width: `${uploadProgress}%` }}
                  ></div>
                </div>
              </>
            ) : (
              <div>
                <p className="success-messages">
                  Produsul s-a încărcat cu succes!
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default AddProject;
